// extracted by mini-css-extract-plugin
module.exports = {"barContainer":"ProgressBar_barContainer__35Bwa","barContent":"ProgressBar_barContent__1BRrd","percentage":"ProgressBar_percentage__3VC1G"};